import { useOfficeComponentContext } from '@office-start/component-context-service';
import { OfficeWorkload } from '@office-start/officehome-types';
export var useOcidValue = function (area) {
    var context = useOfficeComponentContext().data;
    //Default ids will be the welcomeBadge values
    var ocidId = {
        web: 'cmmrvb0fezi',
        desktop: 'cmm97cde5ll',
    };
    switch (area) {
        case 'MyContent':
            ocidId.web = 'cmmcg3fk2g0';
            ocidId.desktop = 'cmmapwu43rs';
            break;
    }
    return (context === null || context === void 0 ? void 0 : context.workload) === OfficeWorkload.Hwa
        ? ocidId.desktop
        : ocidId.web;
};
//# sourceMappingURL=useOcidValue.js.map